module.exports = __webpack_public_path__ + "media/images/products/ht1/ht1-1-400x400-a5cc1c872392f9a6f815d01ca5630a47.png";